import { Injectable } from '@angular/core';
import * as Parse from 'parse';

@Injectable()
export class StripeService {
    createStripeSubscription(sessionId: string) {
        return Parse.Cloud.run('createStripeSubscription', {
            stripeCheckoutSessionId: sessionId
        });
    }
}
